class IsOnline {
  value = $state<boolean>(true);
}

export const isOnline = new IsOnline();